import React from "react"
import Textarea from "@amzn/meridian/textarea"
import Button from "@amzn/meridian/button"
import copyTokens from "@amzn/meridian-tokens/base/icon/copy"
import Icon from "@amzn/meridian/icon"
import {useEffect} from "react"
import {getBagReport, getOVReport, getReport, getLastPackageReport, getCartReport} from "./safetyReport/ReportFormatUtil"

const ReportView = ({inductReport, stowReport, stowOVReport, stagedOVReport, pickedOVReport, pickReport, stageReport, tierData, lastPackageReport}) => {

    const [inductReportValue, setInductReportValue] = React.useState(inductReport)
    const [stowReportValue, setStowReportValue] = React.useState(stowReport)
    const [stowOVReportValue, setStowOVReportValue] = React.useState(stowOVReport)
    const [stagedOVReportValue, setStagedOVReportValue] = React.useState(stagedOVReport)
    const [pickedOVReportValue, setPickedOVReportValue] = React.useState(pickedOVReport)
    const [lastPackageReportValue, setLastPackageReportValue] = React.useState(lastPackageReport)
    const [pickReportValue, setPickReportValue] = React.useState(pickReport)
    const [stageReportValue, setStageReportValue] = React.useState(stageReport)
    const [tierDataValue, setTierDataValue] = React.useState(tierData)
    const [formattedReport, setFormattedReport] = React.useState("")

    useEffect(() => {
        setInductReportValue(JSON.parse(JSON.stringify(inductReport)))
        setStowReportValue(JSON.parse(JSON.stringify(stowReport)))
        setStowOVReportValue(JSON.parse(JSON.stringify(stowOVReport)))
        setStagedOVReportValue(JSON.parse(JSON.stringify(stagedOVReport)))
        setPickedOVReportValue(JSON.parse(JSON.stringify(pickedOVReport)))
        setLastPackageReportValue(JSON.parse(JSON.stringify(lastPackageReport)))
        setPickReportValue(JSON.parse(JSON.stringify(pickReport)))
        setStageReportValue(JSON.parse(JSON.stringify(stageReport)))
        setTierDataValue(JSON.parse(JSON.stringify(tierData)))
        generateFormattedReport()
    }, [inductReport, stowReport, stowOVReport, stagedOVReport, pickedOVReport, pickReport, stageReport, lastPackageReport, tierData])

    const generateFormattedReport = () => {

        const formattedReport = `
        ${getLastPackageReport("Last Package Report", lastPackageReportValue, "$#$")} \n
        ${getReport("Induct", "Inducted", inductReportValue, "$$##$$")} \n
        ${getReport("Stow (Non OV) ", "Stowed", stowReportValue, "$####$")} \n
        ${getOVReport("Stow OV", "Stowed", stowOVReportValue, "$$$###$$")} \n
        ${getBagReport("Pick Bag", "Picked", pickReportValue, tierDataValue, "##$$$")} \n
        ${getOVReport("Pick OV (Package) ", "Picked", pickedOVReportValue, "##$$##$")} \n 
        ${getCartReport("Staged Cart", "Staged", stageReportValue, "$#$#$#$$")} \n
        ${getOVReport("Stage OV (Package) ", "Staged", stagedOVReportValue, "$$#$#$#$")} \n
        `
        setFormattedReport(formattedReport)
    }

    return (
        <React.Fragment>
            <Button onClick={() => navigator.clipboard.writeText(formattedReport)}
                size="large"
            >
                <Icon tokens={copyTokens} /> Copy Statistic Report
            </Button>
            <Textarea
                value={formattedReport}
                placeholder="Metadata"
                label="$$$### Statistic Report ###$$$"
                error={false}
                onChange=""
            />
            <Button type="icon"
                onClick={() => navigator.clipboard.writeText(formattedReport)}>
                <Icon tokens={copyTokens}>Settings</Icon>
            </Button>
        </React.Fragment>
    )
}

export default ReportView;


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/ReportView.js